import { render, staticRenderFns } from "./Mailboxes.vue?vue&type=template&id=3d3f6919&scoped=true"
import script from "./Mailboxes.vue?vue&type=script&lang=js"
export * from "./Mailboxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3f6919",
  null
  
)

export default component.exports